module.exports = __webpack_public_path__ + "img/p-one-step-08.f6a591e7.png";